import request from '@/utils/request'

export function getCropInfo(params) {
    return request({
        url: `/dingTalk/nb/config`,
        method: 'get',
        params
    })
}

export function authenticate(data) {
    return request({
        url: `/dingTalk/nb/authenticate`,
        method: 'post',
        data
    })
}
export function getNbData(params) {
    return request({
        url: `/dingTalk/nb/getNbData`,
        method: 'get',
        params
    })
}
export function get2024NbData(params) {
    return request({
        url: `/dingTalk/nb/2024/getNbData`,
        method: 'get',
        params
    })
}
export function get2025NbData(params) {
    return request({
        url: `/dingTalk/nb/2025/getNbData`,
        method: 'get',
        params
    })
}
export function sign(params) {
    return request({
        url: `/dingTalk/nb/sign`,
        method: 'get',
        params
    })
}

export default { getCropInfo, authenticate,getNbData, sign }
